import React from 'react'
import classnames from 'classnames'
import './Avatar.css'

const Avatar = props => {
  const { className, style, initials, imgSrc, small, onClick } = props
  return (
    <div
      onClick={onClick}
      className={classnames(
        'cookunity__avatar_container',
        { small, no_border: !!imgSrc },
        className
      )}
      style={style}>
      <div className="avatar">
        {imgSrc ? (
          <img className="avatar_img" src={imgSrc} alt="avatar" />
        ) : (
          <p className="initials">{initials}</p>
        )}
      </div>
    </div>
  )
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.jsx